import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const PageNotFound = ({ t }) => {
	return (
		<Paper
			sx={{
				padding: '15px',
				backgroundColor: (theme) => theme.palette.common.white
			}}
		>
			<Typography component='h2' variant='h4'>
				{t('pageNotFound:headerText')}
			</Typography>
			<Typography component='p'>{t('pageNotFound:contentText')}</Typography>
		</Paper>
	);
};

PageNotFound.propTypes = {
	t: PropTypes.func
};

export default withTranslation('pageNotFound')(PageNotFound);
